import { Button, FilterCommon, Modal, Pagination, Table } from "@/components";
import {
  ANNUAL_LEAVE_OVERVIEW_SCREEN,
  filtersJson,
  getMessageResponseType,
  handleMessagesAPI,
  PAGINATION_DEFAULT,
} from "@/utils";
import { mapState } from "vuex";
import { annualLeaveOverviewColumns } from "../../constants";
import AnnualLeaveModal from "./AnnualLeaveModal.vue";

export default {
  name: "LeaveManagement",
  components: {
    FilterCommon,
    Button,
    Pagination,
    Modal,
    AnnualLeaveModal,
    Table,
  },
  data() {
    return {
      dataFilterDefault: {},
      loading: false,
      columns: annualLeaveOverviewColumns,
      visibleModal: false,
      activeRecord: {},
      filter: PAGINATION_DEFAULT,
      ANNUAL_LEAVE_OVERVIEW_SCREEN,
      filterList: filtersJson[ANNUAL_LEAVE_OVERVIEW_SCREEN],
    };
  },
  computed: {
    ...mapState({
      annualLeaveList: (state) => state.annualLeave.annualLeaveList,
      pages: (state) => state.annualLeave.pages,
    }),
  },
  watch: {
    filter() {
      this.getAnnualLeaveList(this.filter);
    },
  },
  created() { },
  methods: {
    customRow(record) {
      return {
        style: {
          cursor: "pointer",
        },
        on: {
          click: () => {
            this.activeRecord = record;
            this.visibleModal = true;
          },
        },
      };
    },
    handleFilter(filter) {
      this.filter = { ...this.filter, ...filter, page: 1 };
    },
    getAnnualLeaveList() {
      this.$store.dispatch("user/loadingRequest");
      this.$store
        .dispatch("annualLeave/getAnnualLeaveList", this.filter)
        .catch((error) => {
          handleMessagesAPI(error.response.data);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },
    handleChangePagination(payload) {
      this.filter = { ...this.filter, ...payload };
    },
    onCancel() {
      this.visibleModal = false;
    },
    handleExport() {
      this.$store.dispatch("user/loadingRequest");
      this.$store
        .dispatch("annualLeave/exportAnnualLeaveList", this.filter)
        .then((res) => {
          handleMessagesAPI(res?.headers);
        })
        .catch(async (error) => {
          const errorObject = await getMessageResponseType(error);
          handleMessagesAPI(errorObject);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },
  },
};
